export const hideMobileNav = (screenSize: number, setShowNavPageMobile: any): void => {
    if (screenSize < 600) {
        setShowNavPageMobile(false);
    }
}